import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { TypeParam } from '../_helpers/alertsFilterParams';
import { AlertsDashboardAction } from '../alertsDashboard.action';
import { AlertsDashboardColumnFilterNames } from '../alertsDashboard.interface';

export const changeDashboardAlertsFilterEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(AlertsDashboardAction.updateFilter),
  mergeMap((payload) => {
    if (Object.hasOwn(payload, AlertsDashboardColumnFilterNames.type)) {
      if (!payload.type) {
        return [
          RouterAction.removeParam(TypeParam.name),
        ];
      }

      return [
        RouterAction.addParam(TypeParam.nameAndValue(payload.type)),
      ];
    }

    return [];
  }),
);
